import axios from "axios";
import React, { useEffect, useState } from "react";

const AddBrand = () => {
  const [brand, setBrand] = useState("");
  const [error, setError] = useState("");
  const [success, setSuccess] = useState(false);
  const [brandList, setBrandList] = useState([]);
  const [selectBrandCat, setSelectBrandCat] = useState([]);
  const [selectCatBrand, setSelectCatBrand] = useState("");
  const [category, setCategory] = useState("");
  const [subCategory, setSubCategory] = useState([])

  const handleSubmit = async (e) => {
    e.preventDefault();

    const data = {
      brand,
    };

    try {
      const response = await axios.post("/add-brand", data);
      setSuccess(response.data);
      setBrand("");
    } catch (error) {
      setError("Faild");
      return;
    }
  };
  setTimeout(() => {
    setSuccess(false);
  }, 1000);

  useEffect(() => {
    const getBrand = async () => {
      try {
        const response = await axios.get("/get-brand");
        setBrandList(response.data);
      } catch (error) {
        return;
      }
    };
    getBrand();
  }, [success]);

  useEffect(() => {
    if (!selectCatBrand) {
      return;
    }
    const getAllCategory = async () => {
      try {
        const response = await axios.get("/get-brand-category", {
          params: {
            brand: selectCatBrand,
          },
        });
        setSelectBrandCat(response.data);
      } catch (error) {
        return;
      }
    };
    getAllCategory();
  }, [selectCatBrand]);

  const getBrandName = (brand) => {
    setSelectCatBrand(brand);
  };
  const getCategoryName = (category, brand) => {
    setCategory(category);
    setBrand(brand);
  };

  console.log("setCategory", category, "brand", brand);

  useEffect(() => {
    if (!brand || !category) {
      return;
    }
    const getsubcategory = async () => {
      try {
        const response = await axios.get(
          `/get-sub-category/${brand}/${category}`
        );
        setSubCategory(response.data);
      } catch (error) {
        return;
      }
    };
    getsubcategory();
  }, [brand, category]);

  return (
    <div className="main_wrp">
      <div className="main_page_wrp">
        <div className="head_wrp">
          <h5>
            Add <em>Brand</em>
          </h5>
        </div>
        <div className="main_body_wrp">
          <form onSubmit={handleSubmit}>
            <div className="add_main">
              <div className="add_t_form">
                <div className="in_main">
                  <label>Brand</label>
                  <input
                    value={brand}
                    onChange={(e) => setBrand(e.target.value)}
                    required
                  />
                </div>
              </div>

              <div>
                <button type="submit" className="btn_submit_form">
                  <span>Submit</span>
                </button>
              </div>

              {error && <small style={{ color: "red" }}>{error}</small>}
              {success && (
                <small style={{ color: "green" }}>
                  Product added successfully!
                </small>
              )}
            </div>
          </form>
          <div className="brand_list">
            <div className="list_sub">
              <strong>Brand </strong>
              {brandList.length === 0 ? (
                <p>There no brand</p>
              ) : (
                brandList.map((item, i) => (
                  <p key={i} onClick={() => getBrandName(item.brand)}>
                    {item.brand}
                  </p>
                ))
              )}
            </div>
            <div className="list_sub">
              <strong>Category</strong>
              <div>
                {selectBrandCat.length === 0 ? (
                  <p>There no category</p>
                ) : (
                  selectBrandCat.map((item, i) => (
                    <p
                      key={i}
                      onClick={() => getCategoryName(item.category, item.brand)}
                    >
                      {item.category}
                    </p>
                  ))
                )}
              </div>
            </div>
            <div className="list_sub">
              <strong>Sub Category</strong>
              <div>
                {subCategory.length === 0 ? (
                  <p>There no sub category</p>
                ) : (
                  subCategory.map((item, i) => <p key={i}>{item}</p>)
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AddBrand;
